import { motion } from 'framer-motion';

const CTA = () => {
  return (
    <section id='contact' className='py-20 bg-white'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className='relative overflow-hidden rounded-3xl bg-linear-to-br from-primary-600 to-primary-800 p-8 md:p-16'>
            {/* Background Pattern */}
            <div className='absolute inset-0 opacity-10'>
              <svg className='w-full h-full' viewBox='0 0 100 100' preserveAspectRatio='none'>
                <defs>
                  <pattern id='grid' width='10' height='10' patternUnits='userSpaceOnUse'>
                    <path d='M 10 0 L 0 0 0 10' fill='none' stroke='white' strokeWidth='0.5' />
                  </pattern>
                </defs>
                <rect width='100' height='100' fill='url(#grid)' />
              </svg>
            </div>

            <div className='relative text-center'>
              <h2 className='text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6'>
                Siap Mengubah Bisnis Anda?
              </h2>
              <p className='text-xl text-primary-100 max-w-2xl mx-auto mb-10'>
                Dapatkan kartu PVC/Digital dengan aplikasi gratis selamanya. Konsultasi gratis tanpa
                kewajiban!
              </p>

              <div className='flex flex-col sm:flex-row items-center justify-center gap-4'>
                <a
                  href='https://wa.me/6285235662062?text=Halo,%20saya%20ingin%20konsultasi%20tentang%20ScanKartu'
                  className='inline-flex items-center space-x-3 bg-white text-primary-600 hover:bg-gray-100 font-semibold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg'
                >
                  <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                    <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z' />
                  </svg>
                  <span>0852-3566-2062</span>
                </a>
                <a
                  href='https://wa.me/6285235662062?text=Halo,%20mohon%20info%20lebih%20lanjut'
                  className='inline-flex items-center space-x-2 bg-primary-700 text-white hover:bg-primary-600 font-semibold py-4 px-8 rounded-full transition-all duration-300 border-2 border-white/30'
                >
                  <span>Chat Sekarang</span>
                  <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M14 5l7 7m0 0l-7 7m7-7H3'
                    />
                  </svg>
                </a>
              </div>

              {/* Trust Badges */}
              <div className='mt-12 flex flex-wrap items-center justify-center gap-6 text-primary-100'>
                <div className='flex items-center space-x-2'>
                  <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    />
                  </svg>
                  <span>Gratis Konsultasi</span>
                </div>
                <div className='flex items-center space-x-2'>
                  <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    />
                  </svg>
                  <span>Pengiriman Cepat</span>
                </div>
                <div className='flex items-center space-x-2'>
                  <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    />
                  </svg>
                  <span>Kualitas Terjamin</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
